import React from "react";
import { AlertTriangle } from "lucide-react";

export default function MockedBadge({ service = "stripe", label, className = "" }) {
  const title = label || (service === "stripe" ? "Stripe" : service === "resend" ? "Resend" : service);
  return (
    <span
      className={`eb-mocked-badge ${className}`}
      data-testid={`mocked-badge-${service}`}
      aria-label={`Mocked integration — ${title}`}
    >
      <AlertTriangle className="w-3 h-3" />
      Mocked — {title}
    </span>
  );
}
